/**
 * Created by zhoujf on 2024/03/27.
 *
 * getCookie        获取cookie
 * setCookie        设置cookie
 * delCookie        删除cookie
 * colorRgb         颜色转换
 */
export default {
  // 读取cookie，需要注意的是cookie是不能存中文的，如果需要存中文，解决方法是后端先进行编码encode()，
  // 前端取出来之后用decodeURI(&#39;string&#39;)解码。（安卓可以取中文cookie，IOS不行）
  getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) {
      // return true
      return arr[2]
    } else {
      return false
    }
  },
  // 设置cookie   name为cookie的名字，value是值，exdays为过期时间（天数）
  setCookie(name, value, exdays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    document.cookie = name + "=" + value + ((exdays == null) ? "" : ";expires=" + exdate.toGMTString())
  },
  // 删除cookie
  delCookie(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = this.getCookie(name);
    if (cval != null)
      document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString()
  },
  // 颜色转换
  colorRgb(val, alpha) {
    let color = val
    let pattern = /^#([0-9|A-F]{3}|[0-9|A-F]{6})$/;
    if (color && pattern.test(color)) {
      if (color.length == 4) {
        // 将三位转换为六位
        color = '#' + color[1] + color[1] + color[2] + color[2] + color[3] + color[3];
      }
      //处理六位的颜色值
      let colorNew = [];
      for (let i = 1; i < 7; i += 2) {
        colorNew.push(parseInt("0x" + color.slice(i, i + 2)));
      }
      return `rgba(${colorNew.join(",")},${alpha || 1})`;
    }
    return color;
  }
}

/**
 * 根据文件字节大小获取合理单位的文件大小
 * @param {number} size // byte
 * @returns {string} eg:1024byte->1KB
 */
export function getFileSize(size) {
  if (!size) return ''
  const num = 1024.0 // byte
  if (size < num) return size + 'B'
  if (size < Math.pow(num, 2)) return (size / num).toFixed(2) + 'KB' //kb
  if (size < Math.pow(num, 3)) return (size / Math.pow(num, 2)).toFixed(2) + 'MB' //M
  if (size < Math.pow(num, 4)) return (size / Math.pow(num, 3)).toFixed(2) + 'GB' //G
  return (size / Math.pow(num, 4)).toFixed(2) + 'T' //T
}


export function formatFileSize(size) {
  if (!size) {
    return 0;
  }
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
  let idx = 0;

  while (size >= 1024 && idx < units.length - 1) {
    size /= 1024;
    idx++;
  }
  return parseFloat(size).toFixed(2) + ' ' + units[idx];
}


// 格式化时间
export function dateFormat(_date = Date.now(), fmt = 'YYYY-MM-DD HH:mm:ss') {
	var oldTime = new Date(_date).getTime()
	var date = new Date(oldTime)
	let ret
	const opt = {
		'Y+': date.getFullYear().toString(), // 年
		'M+': (date.getMonth() + 1).toString(), // 月
		'D+': date.getDate().toString(), // 日
		'H+': date.getHours().toString(), // 时
		'm+': date.getMinutes().toString(), // 分
		's+': date.getSeconds().toString(), // 秒
		// 有其他格式化字符需求可以继续添加，必须转化成字符串
	}
	for (let k in opt) {
		ret = new RegExp('(' + k + ')').exec(fmt)
		if (ret) {
			fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'))
		}
	}
	return fmt
}


// WEBPACK FOOTER //
// ./src/util/utils.js